(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-2026"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = () => {
    const banner = document.getElementById('halloween-2026');
    if (!banner || banner.dataset.initialized) return;
    banner.dataset.initialized = 'true';
    const end = Date.parse(banner.dataset.hwEnd);
    const time = banner.querySelector('.hw-time');
    let interval;
    const update = () => {
      const seconds = Math.floor((end - Date.now()) / 1000);
      if (seconds <= 0) {
        banner.remove();
        if (interval) window.clearInterval(interval);
        return false;
      }
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor(seconds % 86400 / 3600);
      const minutes = Math.floor(seconds % 3600 / 60);
      const secs = seconds % 60;
      time.textContent = days + 'd ' + String(hours).padStart(2,'0') + 'h ' + String(minutes).padStart(2,'0') + 'm ' + String(secs).padStart(2,'0') + 's';
      return true;
    };
    if (update()) interval = window.setInterval(() => {
      if (!banner.isConnected) window.clearInterval(interval);
      else update();
    },1000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup,{once:true});
  else setup();
  document.addEventListener('shopify:section:load',setup);
})();

  } catch(e) { console.error(e); }
})();
})();
